import { ObjectSchemaDefinition, object, string, ObjectSchema } from 'yup';

export const validationSchema = object().shape({
  option: string().label('The options').trim().required('The options needs to be filled in.').max(255),
});

export const buildDynamicValidationSchema = (options: string[]): ObjectSchema => {
  const rules = options.reduce<ObjectSchemaDefinition<Record<typeof options[number], string>, object>>((acc, name) => {
    acc[name] = string().trim().required(`This field needs to be filled in.`);
    return acc;
  }, {});

  return object().shape(rules);
};
